import React from "react";
import "./Loader.scss";

export default function Loader({ loading = true }) {
	return (
		<div className={`loader-wrapper ${loading ? "" : "loaded"}`}>
			<div className="loader"></div>
		</div>
	);
}
